import AnchorLink from './anchor-link';

export default AnchorLink;
export { AnchorLink };